<template>
  <section id="timeline" class="timeline section">

    <mobile-nav></mobile-nav>

    <div class="container">
      <h1 ref="heading">Life’s Moments</h1>
      <div class="intro" ref="intro">
        <p>At what age did the UK first start planning...<br/> and when did it actually happen?</p>
      </div>

      <div class="svg">
        <snap-timeline></snap-timeline>
      </div>
    </div>

    <filters></filters>

    <back-to-top></back-to-top>

    <mobile-footer></mobile-footer>

  </section>
</template>

<script>
import MobileFooter from '@/components/MobileFooter'
import BackToTop from '@/components/BackToTop'
import MobileNav from '@/components/MobileNav'
import MobileShare from '@/components/MobileShare'
import { TweenMax, Power1 } from 'gsap'
import { Bus } from '@/components/Bus'
import Filters from '@/components/Filters'
import SnapTimeline from '@/components/SnapTimeline'
import Chart from '@/components/Chart'

export default {
  name: 'Timeline',
  data () {
    return {
      selected: null,
      active: ''
    }
  },
  components: {
    'mobile-footer': MobileFooter,
    'back-to-top': BackToTop,
    'mobile-nav': MobileNav,
    'mobile-share': MobileShare,
    'snap-timeline': SnapTimeline,
    'filters': Filters,
    'line-chart': Chart
  },
  methods: {
    checkQueryString () {
      const filters = this.$route.query
      Object.keys(filters).forEach(key => {
        this.$store.commit('setFilter', {
          [key]: filters[key]
        })
      })
      this.$store.dispatch('applyFilters')
      Bus.$emit('filterChanged')
    }
  },
  mounted: function () {
    let heading = this.$refs.heading
    let intro = this.$refs.intro

    TweenMax.to(heading, 0.4, {
      opacity: 1,
      y: '+=20px',
      ease: Power1.easeInOut
    })

    TweenMax.to(intro, 0.6, {
      opacity: 1,
      y: '+=20px',
      ease: Power1.easeInOut,
      delay: 0.4
    })
  },
  beforeMount: function () {
    this.checkQueryString()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

@import '../styles/core/vars.scss';
@import '../styles/core/mixins.scss';

.timeline {
  color: $c-white;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  width: 100%;
  z-index: 9999;

  h1,
  .intro {
    opacity: 0;
  }

  h1{
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 12px;

    @include respond-to('medium'){
      font-size: 36px;
      line-height: 41px;
      margin-bottom: 30px;
    }
  }

  .intro p{
    font-size: 12px;
    line-height: 20px;

    @include respond-to('medium'){
      font-size: $fs-body;
      line-height: $lh-body;
    }
  }

  h2 {
    text-transform: none;
    font-size: 24px;
    margin: 20px 0;
  }

  .svg {
    position: relative;
    top: 50%;
    left: 0;
    // transform: translateY(-20%);
    display: block;
    width: 100vw;

    @include respond-to('medium') {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 0;
    }
  }

  @media screen and (max-height: 820px) {
    .container {
      position: relative;
    }
    .svg {
      position: relative;
      top: 50%;
      transform: translateY(-20%);
      left: 0;
      top: 0;
    }
  }
}

.info-window {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/views/Timeline.vue